import React from "react";
import SubscriberDetailsView from "../../../../views/dashboard/subscribers/Details";

const SubscriberDetails = () => {
  return <SubscriberDetailsView />;
};

export default SubscriberDetails;
